<template>
  <div id="app">

    <v-app id="inspire" light>
      <v-card color="grey lighten-5" flat>
        <v-layout row wrap>
          <v-flex xs12 sm12>
            <v-toolbar size="120px" dark color="info">
              <v-toolbar-title>Hesap Ekstresi</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-text-field flat="" solo-inverted="" hide-details v-model="search3" label=" Ara" append-icon="search">
              </v-text-field>



              <v-menu offset-y>
                <v-btn slot="activator" dark icon>
                  <v-icon>more_vert</v-icon>
                </v-btn>
                <v-list>
<!--
                  <v-list-tile @click="getListHtml()">
                    <v-list-tile-title>Html İndir</v-list-tile-title>
                  </v-list-tile> -->


                  <v-list-tile @click="getListExcel()">
                    <v-list-tile-title>Excel İndir</v-list-tile-title>
                  </v-list-tile>

                </v-list>
              </v-menu>


            </v-toolbar>
          </v-flex>


          <v-container v-show="EkstreHesap.RaporDvzTip == 0" fluid="">
            <v-layout row wrap>

              <v-flex xs12 sm6 md4 pa-1>
                <v-card   class="white--text">
                   <v-layout row wrap="">
                    <v-flex xs2 sm2 md2>
                      <v-layout align-center="" justify-center="" fill-height="">
                        <v-icon color="#ff6347" large="">cached</v-icon>
                      </v-layout>
                    </v-flex>
                    <v-flex xs12 sm10 md10>

                      <v-card-title primary-title="">
                        <v-flex xs12 sm12 md12>
                          <v-layout>
                            <v-flex xs12 sm6 md6>
                              <v-list-tile-title>
                                <span class="subheading grey--text font-weight-">
                                  Devir Borç
                                </span>
                              </v-list-tile-title>
                            </v-flex>
                            <v-flex xs12 sm9 md8>
                              <v-list-tile-title>
                                <span class="subheading grey--text  font-weight-">
                                  : {{ devirborc | moneyformat }}{{getparabirimi()}}
                                </span>
                              </v-list-tile-title>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                          <v-layout>
                            <v-flex xs12 sm6 md6>
                              <v-list-tile-title>
                                <span class="subheading grey--text  font-weight-">
                                  Devir Alacak
                                </span>
                              </v-list-tile-title>
                            </v-flex>
                            <v-flex xs12 sm9 md8>
                              <v-list-tile-title>
                                <span class="subheading grey--text  font-weight-">
                                  : {{ deviralacak | moneyformat }}{{getparabirimi()}}
                                </span>
                              </v-list-tile-title>
                            </v-flex>
                          </v-layout>
                        </v-flex>


                      </v-card-title>

                    </v-flex>
                  </v-layout>
                  <v-divider light></v-divider>
                  <v-card-actions class="pa-3">
                    <span class="subheading grey--text  font-weight-"> Devir Bakiye : {{ devirbakiye }}</span>
                    <v-spacer></v-spacer>
                  </v-card-actions>
                </v-card>
              </v-flex>

              <v-flex xs12 sm6 md4 pa-1>
                <v-card  class="white--text">
                  <v-layout>
                    <v-flex xs2 sm2 md2>
                      <v-layout align-center="" justify-center="" fill-height="">
                        <v-icon color="#ff6347" large="">layers</v-icon>
                      </v-layout>
                    </v-flex>
                    <v-flex xs12 sm10 md10>

                      <v-card-title primary-title="">
                        <v-flex xs12 sm12 md12>
                          <v-layout>
                            <v-flex xs12 sm6 md6>
                              <v-list-tile-title>
                                <span class="subheading grey--text  font-weight-">
                                  Dönem Borç
                                </span>
                              </v-list-tile-title>
                            </v-flex>
                            <v-flex xs12 sm6 md6>
                              <v-list-tile-title>
                                <span class="subheading grey--text  font-weight-">
                                  : {{ donemborc | moneyformat }}{{getparabirimi()}}
                                </span>
                              </v-list-tile-title>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                          <v-layout>
                            <v-flex xs12 sm6 md6>
                              <v-list-tile-title>
                                <span class="subheading grey--text  font-weight-">
                                  Dönem Alacak
                                </span>
                              </v-list-tile-title>
                            </v-flex>
                            <v-flex xs12 sm6 md6>
                              <v-list-tile-title>
                                <span class="subheading grey--text  font-weight-">
                                  : {{ donemalacak | moneyformat }}{{getparabirimi()}}
                                </span>
                              </v-list-tile-title>
                            </v-flex>
                          </v-layout>
                        </v-flex>


                      </v-card-title>

                    </v-flex>
                  </v-layout>
                  <v-divider light></v-divider>
                  <v-card-actions class="pa-3"> <span class="subheading grey--text  font-weight-">
                      Dönem Bakiye : {{ donembakiye }} </span>
                    <v-spacer></v-spacer>
                  </v-card-actions>
                </v-card>
              </v-flex>

              <v-flex xs12 sm12 md4 pa-1>
                <v-card  class="white--text">
                  <v-layout>
                    <v-flex xs2 sm2 md2>
                      <v-layout align-center="" justify-center="" fill-height="">
                        <v-icon color="#ff6347" large="">queue</v-icon>
                      </v-layout>
                    </v-flex>
                    <v-flex xs12 sm10 md10>

                      <v-card-title primary-title="">
                        <v-flex xs12 sm12 md12>
                          <v-layout>
                            <v-flex xs12 sm6 md6>
                              <v-list-tile-title>
                                <span class="subheading grey--text  font-weight-">
                                  Toplam Borç
                                </span>
                              </v-list-tile-title>
                            </v-flex>
                            <v-flex xs12 sm6 md6>
                              <v-list-tile-title>
                                <span class="subheading grey--text  font-weight-">
                                  : {{ toplamborc | moneyformat }}{{getparabirimi()}}
                                </span>
                              </v-list-tile-title>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                          <v-layout>
                            <v-flex xs12 sm6 md6>
                              <v-list-tile-title>
                                <span class="subheading grey--text  font-weight-">
                                  Toplam Alacak
                                </span>
                              </v-list-tile-title>
                            </v-flex>
                            <v-flex xs12 sm6 md6>
                              <v-list-tile-title>
                                <span class="subheading grey--text  font-weight-">
                                  : {{ toplamalacak | moneyformat }}{{getparabirimi()}}
                                </span>
                              </v-list-tile-title>
                            </v-flex>
                          </v-layout>
                        </v-flex>


                      </v-card-title>

                    </v-flex>
                  </v-layout>
                  <v-divider light></v-divider>
                  <v-card-actions class="pa-3"> <span class="subheading grey--text  font-weight-">
                      Toplam Bakiye : {{ toplambakiye }} </span>
                    <v-spacer></v-spacer>
                  </v-card-actions>
                </v-card>
              </v-flex>



            </v-layout>
          </v-container>


          <v-dialog v-model="dialogfiltre" scrollable="" persistent="" max-width="800px">
            <v-card color="grey lighten-5">
              <v-card-title>Filtre Seçimi</v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <v-layout row="" wrap="">
                  <v-flex pa-1 xs12 sm12 md6>
                    <v-card flat="" class="white--text">
                      <v-card color="grey lighten-5" flat="">
                        <v-card-actions>
                          <v-layout justify-space-between column>

                            <v-autocomplete hide-details :items="Referans" clearable
                              v-model="EkstreHesap.IstenilenReferanslar" label="İstenmeyen Referanslar" multiple
                              item-text="ReferansAd" item-value="Kod">
                              <template slot="selection" slot-scope="{ item, index }">
                                <v-chip v-if="index === 0">
                                  <h4> <span>{{ item.Kod }}</span> </h4>
                                </v-chip>
                                <span v-if="index === 1" class="grey--text caption">(+{{
                                  EkstreHesap.IstenilenReferanslar.length - 1 }} diğer kayıt)</span>
                              </template>
                            </v-autocomplete>

                            <v-autocomplete hide-details :items="masrafmerkezi" clearable
                              v-model="EkstreHesap.Masraflar" label="Masraf Merkezi" multiple item-text="Title"
                              item-value="Code">
                              <template slot="selection" slot-scope="{ item, index }">
                                <v-chip v-if="index === 0">
                                  <h4> <span>{{ item.Code }}</span> </h4>
                                </v-chip>
                                <span v-if="index === 1" class="grey--text caption">(+{{
                                  EkstreHesap.Masraflar.length - 1 }} diğer kayıt)</span>
                              </template>
                            </v-autocomplete>

                            <v-autocomplete hide-details clearable :items="hesapgurubu" v-model="EkstreHesap.Gruplar"
                              label="İstenilen Hesap Gurubu" multiple item-text="Title" item-value="Kod"
                              max-height="400">
                            </v-autocomplete>
                          </v-layout>
                        </v-card-actions>
                      </v-card>
                    </v-card>
                  </v-flex>

                  <v-flex pa-1 xs12 sm12 md6>
                    <v-card flat="" class="white--text">
                      <v-card color="grey lighten-5" flat="">
                        <v-card-actions>
                          <v-layout justify-space-between column>
                            <v-autocomplete hide-details clearable :items="Referans"
                              v-model="EkstreHesap.IstenmeyenReferanslar" label="İstenmeyen Referanslar" multiple
                              item-text="ReferansAd" item-value="Kod">
                              <template slot="selection" slot-scope="{ item, index }">
                                <v-chip v-if="index === 0">
                                  <h4> <span>{{ item.Kod }}</span> </h4>
                                </v-chip>
                                <span v-if="index === 1" class="grey--text caption">(+{{
                                  EkstreHesap.IstenmeyenReferanslar.length - 1 }} diğer kayıt)</span>
                              </template>
                            </v-autocomplete>


                            <v-autocomplete hide-details clearable :items="evraktipi" v-model="EkstreHesap.Evraklar"
                              label="Evrak Tipi" multiple item-text="Title" item-value="Evrakkod">
                              <template slot="selection" slot-scope="{ item, index }">
                                <v-chip v-if="index === 0">
                                  <h4> <span>{{ item.Evrakkod }}</span> </h4>
                                </v-chip>
                                <span v-if="index === 1" class="grey--text caption">(+{{
                                  EkstreHesap.Evraklar.length - 1 }} diğer kayıt)</span>
                              </template>
                            </v-autocomplete>



                            <v-autocomplete clearable hide-details="" :items="hesapgurubu"
                              v-model="EkstreHesap.NoGruplar" label="İstenmeyen Hesap Gurubu" multiple item-text="Title"
                              item-value="Kod" max-height="400" persistent-hint></v-autocomplete>
                          </v-layout>
                        </v-card-actions>
                      </v-card>
                    </v-card>
                  </v-flex>




                </v-layout>
              </v-card-text>

              <v-divider></v-divider>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" flat @click.native="filtreiptal()">İptal</v-btn>
                <v-btn color="blue darken-1" flat @click.native="filtrekayit()">Fİltrelerİ Uygula</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>


          <v-container fluid="">



            <v-form ref="formcariyegore" v-model="valid" lazy-validation>
              <v-card flat>
                <v-flex>
                  <v-layout row wrap="" class="pa-3 project overdue">

                    <v-flex xs12 sm6 md2>
                      <tarihcomp :etiket="'Başlangıç Tarihi'" v-bind:defaultvalue="'ok'"
                        v-bind:value="EkstreHesap.BaslangicTarih" :rules="[v => !!v || 'Lütfen tarih seçiniz']"
                        v-model="EkstreHesap.BaslangicTarih"></tarihcomp>
                    </v-flex>

                    <v-flex xs12 sm6 md2>
                      <tarihcomp :etiket="'Bitiş Tarihi'" :rules="[v => !!v || 'Lütfen tarih seçiniz']"
                        v-bind:defaultvalue="'ok'" v-bind:value="EkstreHesap.BitisTarih"
                        v-model="EkstreHesap.BitisTarih">
                      </tarihcomp>
                    </v-flex>

                    <v-flex xs12 sm6 md2>

                      <v-radio-group v-model="EkstreHesap.RaporTip" row label="Rapor Tipi" column>
                        <v-radio label="Detay" :value="false"></v-radio>
                        <v-radio label="Özet" :value="true"> </v-radio>
                      </v-radio-group>
                    </v-flex>

                    <v-flex>
                      <v-layout>
                        <div v-if="load1">
                          <v-btn color="info" @click="getList()" fab small="" dark>
                            <v-icon>search</v-icon>
                          </v-btn>
                        </div>

                        <!-- <v-badge color="white" :overlap="true">
                        <template v-slot:badge>
                          <v-icon v-if="filtrevarmi" large color="green">
                            check_circle_outline </v-icon>
                        </template>

                        <v-btn small="" @mouseenter="tooltip = true" @mouseleave="tooltip = false" ref="fab"
                          @click="filtrele()" color="info" fab dark>
                          <v-icon>filter_list</v-icon>
                        </v-btn>
                        <v-tooltip bottom="" :activator="el" v-model="tooltip">
                          <span>Arama Filtresi Ekle</span>
                        </v-tooltip>
                      </v-badge> -->

                        <!--
                      <v-btn small="" @mouseenter="tooltip = true" @mouseleave="tooltip = false" ref="fab"
                        @click="filtrele()" color="info" fab dark>
                        <v-icon>filter_list</v-icon>
                      </v-btn>
                      <v-tooltip bottom="" :activator="el" v-model="tooltip">
                        <span>Arama Filtresi Ekle</span>
                      </v-tooltip> -->

                      </v-layout>
                    </v-flex>

                    <v-flex v-show="EkstreHesap.RaporDvzTip == 1 || EkstreHesap.RaporDvzTip == 2" xs12 sm12 md12>
                      <v-layout justify-end="" fill-height="">
                        <v-btn @click="detayaGit()" flat color="info">Genel toplamlarını görmek için tıklayınız.</v-btn>
                      </v-layout>

                    </v-flex>

                  </v-layout>

                </v-flex>
              </v-card>
            </v-form>

            <v-layout>

              <v-flex pt-2 xs12 sm12 md12>
                   <v-layout class=" project overdue" row wrap>
                     <v-flex  xs12 sm12 md12>
                <v-card flat>
                  <v-data-table dense :headers="headers" class="elevation-1" :rows-per-page-items=[50,100]
                    :loading="progress" :items="items" :search="search3">
                    <v-progress-linear slot="progress" indeterminate></v-progress-linear>
                    <template slot="items" slot-scope="props">
                      <td class="text-xs-left">{{ props.item.Tarih | dateformat }}</td>
                      <td class="text-xs-left">{{ props.item.Evrak.Evrakkod }}</td>
                      <td class="text-xs-left">{{ props.item.Evrakno}}</td>
                      <td class="text-xs-left">{{ props.item.Aciklama}}</td>
                      <td class="text-xs-left">{{ props.item.Vade | dateformat}}</td>



                      <td v-if="EkstreHesap.RaporDvzTip==2" class="text-xs-right">{{ props.item.Tutar | moneyformat}}
                      </td>

                      <td v-if="EkstreHesap.RaporDvzTip==2" class="text-xs-center">{{ props.item.BA}}
                      </td>


                      <td v-if="EkstreHesap.RaporDvzTip==1 || EkstreHesap.RaporDvzTip==2" class="text-xs-center">
                        {{ props.item.Doviz.DovizKod }}
                      </td>


                      <td v-if="EkstreHesap.RaporDvzTip==0" class="text-xs-right">{{ props.item.Borc | moneyformat}}

                      <td v-if="EkstreHesap.RaporDvzTip==1 || EkstreHesap.RaporDvzTip==2" class="text-xs-right">
                        {{ props.item.DvzBorc | moneyformat}}</td>

                      <td v-if="EkstreHesap.RaporDvzTip==0" class="text-xs-right">{{ props.item.Alacak | moneyformat}}
                      </td>

                      <td v-if="EkstreHesap.RaporDvzTip==1 || EkstreHesap.RaporDvzTip==2" class="text-xs-right">
                        {{ props.item.DvzAlacak | moneyformat}}</td>

                      <td v-if="EkstreHesap.RaporDvzTip==0" class="text-xs-right">
                        {{ props.item.Bakiye | bakiyekontrol }}</td>



                    </template>
                    <v-alert slot="no-results" :value="true" color="error" icon="warning">
                      Aradığınız "{{ search3 }}" kelimesi ile ilgili herhangi bir kayıt bulunamadı..
                    </v-alert>
                  </v-data-table>
                </v-card>
                     </v-flex>
                   </v-layout>

              </v-flex>

            </v-layout>
          </v-container>



          <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'"
                  :left="x === 'left'" :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'"
                  v-model="snackbar">
                  {{ text1 }}
                  <v-btn flat color="pink" @click.native="snackbar = false">Kapat</v-btn>
                </v-snackbar>



          <div class="icerik" id="icerik">&nbsp;</div>

          <v-container v-show="EkstreHesap.RaporDvzTip == 1 || EkstreHesap.RaporDvzTip == 2" fluid="">
            <v-flex sm12 md12>
              <v-flex xs12 sm12 md12>
                <v-card flat="" class="black--text">
                  <v-card flat="">
                    <v-card-actions>
                      <v-layout row wrap>
                        <v-flex pb-2 xs12 sm12 md12>
                          <v-layout align-center="" justify-start="" fill-height="">
                            <span class="subheading info--text font-weight-"> Devir Genel Toplamlar
                            </span>
                          </v-layout>
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                          <v-card flat class="black--text">
                            <v-layout row wrap>
                              <v-flex xs12 sm3 md3>
                                <v-layout align-center="" justify-start="" fill-height="">
                                  <span class="body-2 font-weight-"> Döviz Tipi
                                  </span>
                                </v-layout>
                              </v-flex>
                              <v-flex xs12 sm3 md3>
                                <v-layout align-center="" justify-end="" fill-height="">
                                  <span class="body-2 font-weight-">
                                    Devir Borç
                                  </span>
                                </v-layout>
                              </v-flex>

                              <v-flex xs12 sm3 md3>
                                <v-layout align-center="" justify-end="" fill-height="">
                                  <span class="body-2 font-weight-">
                                    Devir Alacak
                                  </span>
                                </v-layout>
                              </v-flex>

                              <v-flex xs12 sm3 md3>
                                <v-layout align-center="" justify-end="" fill-height="">
                                  <span class="body-2 font-weight-">
                                    Devir Bakiye
                                  </span>
                                </v-layout>
                              </v-flex>



                            </v-layout>
                            <v-divider light></v-divider>

                            <v-layout row wrap v-for="item in dovizToplamlar" :key="item.id">
                              <v-flex xs12 sm3 md3>
                                <v-layout align-center="" justify-start="" fill-height="">
                                  <span class="body-2 font-weight-thin">
                                    {{item.Doviz.DovizKod}} </span>
                                </v-layout>
                              </v-flex>

                              <v-flex xs12 sm3 md3>
                                <v-layout align-center="" justify-end="" fill-height="">
                                  <span class="body-2 font-weight-thin">
                                    {{item.DevirBorc | moneyformat}}</span>
                                </v-layout>
                              </v-flex>

                              <v-flex xs12 sm3 md3>
                                <v-layout align-center="" justify-end="" fill-height="">
                                  <span class="body-2n font-weight-thin">
                                    {{item.DevirAlacak | moneyformat}}</span>
                                </v-layout>
                              </v-flex>


                              <v-flex xs12 sm3 md3>
                                <v-layout align-center="" justify-end="" fill-height="">
                                  <span class="body-2 font-weight-thin">
                                    {{item.DevirBakiye | bakiyekontrol}}</span>
                                </v-layout>
                              </v-flex>
                              <v-flex xs12 sm3 md12>
                                <v-divider light></v-divider>
                              </v-flex>
                            </v-layout>
                          </v-card>
                        </v-flex>


                      </v-layout>
                    </v-card-actions>
                  </v-card>
                </v-card>
              </v-flex>
            </v-flex>
          </v-container>

          <v-container v-show="EkstreHesap.RaporDvzTip == 1 || EkstreHesap.RaporDvzTip == 2" fluid="">
            <v-flex sm12 md12>
              <v-flex xs12 sm12 md12>
                <v-card flat="" class="black--text">
                  <v-card flat="">
                    <v-card-actions>
                      <v-layout row wrap>
                        <v-flex pb-2 xs12 sm12 md12>
                          <v-layout align-center="" justify-start="" fill-height="">
                            <span class="subheading info--text font-weight-"> Dönem Genel Toplamlar
                            </span>
                          </v-layout>
                        </v-flex>

                        <v-flex xs12 sm12 md12>
                          <v-card flat class="black--text">

                            <v-layout row wrap>
                              <v-flex xs12 sm3 md3>
                                <v-layout align-center="" justify-start="" fill-height="">
                                  <span class="body-2 font-weight-"> Döviz Tipi
                                  </span>
                                </v-layout>
                              </v-flex>


                              <v-flex xs12 sm3 md3>
                                <v-layout align-center="" justify-end="" fill-height="">
                                  <span class="body-2 font-weight-">
                                    Dönem Borç
                                  </span>
                                </v-layout>
                              </v-flex>

                              <v-flex xs12 sm3 md3>
                                <v-layout align-center="" justify-end="" fill-height="">
                                  <span class="body-2 font-weight-">
                                    Dönem Alacak
                                  </span>
                                </v-layout>
                              </v-flex>

                              <v-flex xs12 sm3 md3>
                                <v-layout align-center="" justify-end="" fill-height="">
                                  <span class="body-2 font-weight-">
                                    Dönem Bakiye
                                  </span>
                                </v-layout>
                              </v-flex>

                            </v-layout>
                            <v-divider light></v-divider>
                            <v-layout row wrap v-for="item in dovizToplamlar" :key="item.id">
                              <v-flex xs12 sm2 md3>
                                <v-layout align-center="" justify-start="" fill-height="">
                                  <span class="body-2 font-weight-thin">
                                    {{item.Doviz.DovizKod}} </span>
                                </v-layout>
                              </v-flex>
                              <v-flex xs12 sm3 md3>
                                <v-layout align-center="" justify-end="" fill-height="">
                                  <span class="body-2 font-weight-thin">
                                    {{item.DonemBorc | moneyformat}}</span>
                                </v-layout>
                              </v-flex>
                              <v-flex xs12 sm3 md3>
                                <v-layout align-center="" justify-end="" fill-height="">
                                  <span class="body-2 font-weight-thin">
                                    {{item.DonemAlacak | moneyformat}}
                                  </span>
                                </v-layout>
                              </v-flex>

                              <v-flex xs12 sm3 md3>
                                <v-layout align-center="" justify-end="" fill-height="">
                                  <span class="body-2 font-weight-thin">
                                    {{item.DonemBakiye | bakiyekontrol}}
                                  </span>
                                </v-layout>
                              </v-flex>
                              <v-flex xs12 sm12 md12>
                                <v-divider light></v-divider>
                              </v-flex>
                            </v-layout>
                          </v-card>
                        </v-flex>
                      </v-layout>
                    </v-card-actions>
                  </v-card>
                </v-card>
              </v-flex>
            </v-flex>
          </v-container>

          <v-container v-show="EkstreHesap.RaporDvzTip == 1 || EkstreHesap.RaporDvzTip == 2" fluid="">
            <v-flex sm12 md12>
              <v-flex xs12 sm12 md12>
                <v-card flat="" class="black--text">
                  <v-card flat="">
                    <v-card-actions>
                      <v-layout row wrap>
                        <v-flex pb-2 xs12 sm12 md12>
                          <v-layout align-center="" justify-start="" fill-height="">
                            <span class="subheading info--text font-weight-"> Genel Toplamlar
                            </span>
                          </v-layout>
                        </v-flex>

                        <v-flex xs12 sm12 md12>
                          <v-card flat class="black--text">

                            <v-layout row wrap>
                              <v-flex xs12 sm3 md3>
                                <v-layout align-center="" justify-start="" fill-height="">
                                  <span class="body-2 font-weight-"> Döviz Tipi
                                  </span>
                                </v-layout>
                              </v-flex>


                              <v-flex xs12 sm3 md3>
                                <v-layout align-center="" justify-end="" fill-height="">
                                  <span class="body-2 font-weight-">
                                    Genel Borç
                                  </span>
                                </v-layout>
                              </v-flex>

                              <v-flex xs12 sm3 md3>
                                <v-layout align-center="" justify-end="" fill-height="">
                                  <span class="body-2 font-weight-">
                                    Genel Alacak
                                  </span>
                                </v-layout>
                              </v-flex>

                              <v-flex xs12 sm3 md3>
                                <v-layout align-center="" justify-end="" fill-height="">
                                  <span class="body-2 font-weight-">
                                    Genel Bakiye
                                  </span>
                                </v-layout>
                              </v-flex>
                            </v-layout>
                            <v-divider light></v-divider>

                            <v-layout row wrap v-for="item in dovizToplamlar" :key="item.id">
                              <v-flex xs12 sm3 md3>
                                <v-layout align-center="" justify-start="" fill-height="">
                                  <span class="body-2 font-weight-thin">
                                    {{item.Doviz.DovizKod}} </span>
                                </v-layout>
                              </v-flex>
                              <v-flex xs12 sm3 md3>
                                <v-layout align-center="" justify-end="" fill-height="">
                                  <span class="body-2 font-weight-thin">
                                    {{item.ToplamBorc | moneyformat}}
                                  </span>
                                </v-layout>
                              </v-flex>

                              <v-flex xs12 sm3 md3>
                                <v-layout align-center="" justify-end="" fill-height="">
                                  <span class="body-2 font-weight-thin">
                                    {{item.ToplamAlacak | moneyformat}}
                                  </span>
                                </v-layout>
                              </v-flex>

                              <v-flex xs12 sm3 md3>
                                <v-layout align-center="" justify-end="" fill-height="">
                                  <span class="body-2 font-weight-thin">
                                    {{item.ToplamBakiye | bakiyekontrol}}
                                  </span>
                                </v-layout>
                              </v-flex>
                              <v-flex xs12 sm12 md12>
                                <v-divider light></v-divider>
                              </v-flex>
                            </v-layout>




                          </v-card>
                        </v-flex>


                      </v-layout>
                    </v-card-actions>
                  </v-card>
                </v-card>
              </v-flex>


            </v-flex>
          </v-container>



        </v-layout>
      </v-card>
    </v-app>
  </div>
</template>


<script>
  import auth from '../../../api/auth'
  import tarihcomp from '../customcomp/tarihim'
  import helpers from "@/components/app/customcomp/helpers.js"

  export default {
    data() {
      return {
        sayfayetki: {
          Screen: false,
          Update: false,
          Save: false,
          Delete: false,
          Status: false,
          Message: null,
          islem: 0,
        },
        filtrevarmi: false,
        search: '',
        dovizToplamlar: [],
        headerstl: [{
            text: 'Tarih',
            value: 'Tarih'
          },
          {
            text: 'Evrak Tipi',
            value: 'Evrak.Evrakkod'
          },
          {
            text: 'Evrak No',
            value: 'Evrakno'
          },
          {
            text: 'Açıklama',
            value: 'Aciklama'
          },
          {
            text: 'Vade Tarihi',
            value: 'Vade'
          },
          {
            text: 'Borç',
            value: 'Borc',
            align: 'right'

          }, {
            text: 'Alacak',
            value: 'Alacak',
            align: 'right'
          },

          {
            text: 'Bakiye',
            value: 'Bakiye',
            align: 'center'
          }

        ],
        headersdoviz: [{
            text: 'Tarih',
            value: 'Tarih'
          },
          {
            text: 'Evrak Tipi',
            value: 'Evrak.Evrakkod'
          },
          {
            text: 'Evrak No',
            value: 'Evrakno'
          },
          {
            text: 'Açıklama',
            value: 'Aciklama'
          },
          {
            text: 'Vade Tarihi',
            value: 'Vade'
          },
          {
            text: 'Döviz',
            value: 'Doviz.DovizKod',
          },
          {
            text: 'Borç',
            value: 'Borc',
            align: 'right'

          }, {
            text: 'Alacak',
            value: 'Alacak',
            align: 'right'
          }
        ],
        headerstldoviz: [{
            text: 'Tarih',
            value: 'Tarih'
          },
          {
            text: 'Evrak Tipi',
            value: 'Evrak.Evrakkod'
          },
          {
            text: 'Evrak No',
            value: 'Evrakno'
          },
          {
            text: 'Açıklama',
            value: 'Aciklama'
          },
          {
            text: 'Vade Tarihi',
            value: 'Vade'
          }, {
            text: 'Tutar',
            value: 'Tutar',
            align: 'right'
          },
          {
            text: 'BA',
            value: 'BA',
          },
          {
            text: 'Döviz',
            value: 'Doviz.DovizKod',
          },
          {
            text: 'Borç',
            value: 'Borc',
            align: 'right'

          }, {
            text: 'Alacak',
            value: 'Alacak',
            align: 'right'
          }
        ],
        EkstreHesap: {

          SirketKodu: null,
          Cari: {
            Kod: null
          },
          BaslangicTarih: null,
          BitisTarih: null,
          IstenilenReferanslar: [],
          IstenmeyenReferanslar: [],
          Masraflar: [],
          Gruplar: [],
          NoGruplar: [],
          Evraklar: [],
          Tarihler: 0, // 0 : Tarih,  1 : Vade , 2 : Fatura Tarihi
          RaporTip: false, // false : Detay, true : Ozet
          RaporDvzTip: 0, // 0 : tl, 1 : dvz, 2 : tl+dvz
          BsYolcuDetay: false,
          SifirTutar: false,
          DevirGoster: false,
          AltHesapGosterme: false,
          TlAta: false,
          CoperKayit: false,
          ProgramTip: 0 //0 : Hepsi,1 : Sadece Coper, 2 : Coper Hariç
        },
        devirborc: 0,
        deviralacak: 0,
        devirbakiye: 0,
        donemborc: 0,
        donemalacak: 0,
        donembakiye: 0,
        toplamborc: 0,
        toplamalacak: 0,
        toplambakiye: 0,
        valid: true,

        statecari: [],
        searchcari: '',
        Carihesap: '',
        text1: null,


        loading: false,
        progress: false,
        renk1: 'info',
        items: [],
        load: false,
        load1: true,
        search3: '',
        dialogfiltre: false,
        hesapkodu: [],
        Referans: [],
        masrafmerkezi: [],


        tumsirketler: false,

        anahesap: [],
        hesapgurubu: [],
        evraktipi: [],
        mizan: '',
        butondurum: true,
        snackbar: false,
        y: 'top',
        x: 'right',
        mode: '',
        timeout: 6000,
        tooltip: false,
        el: null,
      }
    },
    beforeRouteEnter(to, from, next) {
      next(vm => {
        vm.prevRoute = from.path
      })
    },
    beforeMount: beforeMount,
    components: {
      tarihcomp
    },
    mounted() {
      // this.el = this.$refs.fab.$el
      this.devirbakiye = '0.00' + this.getparabirimi();
      this.donembakiye = '0.00' + this.getparabirimi();
      this.toplambakiye = '0.00' + this.getparabirimi();
    },
    watch: {
      searchcari(val) {
        val && this.carigetir(val)
      },
      'EkstreHesap.RaporDvzTip': function (a) {

        if (a == 1 || a == 2) {
          this.EkstreHesap.RaporTip = false
        }

        if (a == 0) {
          this.headers = this.headerstl
        } else if (a == 1) {
          this.headers = this.headersdoviz
        } else if (a == 2) {
          this.headers = this.headerstldoviz
        }
      },
      'EkstreHesap.RaporTip': function (a) {
        if (a == false) {
          this.EkstreHesap.RaporDvzTip = 0
        } else if (a == true) {
          if (this.EkstreHesap.RaporDvzTip == 1 || this.EkstreHesap.RaporDvzTip == 2) {
            this.EkstreHesap.RaporDvzTip = 0
          }
        }
      }
    },
    filters: {
      dateformat: function (t) {
        return helpers.dateformat(t);
      },
      moneyformat: function (m) {
        return helpers.moneyformat(m);
      },

      bakiyekontrol: function (m) {
        return helpers.bakiyekontrol(m);
      }
    },
    methods: {
      getparabirimi() {
        return helpers.getparabirimi()
      },
      detayaGit() {

        var target = document.getElementById('icerik')

        var scrollContainer = document.getElementById('icerik')
        do { //find scroll container
          scrollContainer = scrollContainer.parentNode;
          if (!scrollContainer) return;
          scrollContainer.scrollTop += 1;
        } while (scrollContainer.scrollTop == 0);

        var targetY = 0;
        do { //find the top of target relatively to the container
          if (target == scrollContainer) break;
          targetY += target.offsetTop;
        } while (target = target.offsetParent);

        scroll = function (c, a, b, i) {
          i++;
          if (i > 30) return;
          c.scrollTop = a + (b - a) / 30 * i;
          setTimeout(function () {
            scroll(c, a, b, i);
          }, 20);
        }
        // start scrolling
        scroll(scrollContainer, scrollContainer.scrollTop, targetY, 0);

      },
      getList: getList,
      getListHtml: getListHtml,
      getListExcel: getListExcel,
      carigetir: carigetir,
      filtrele: filtrele,
      filtrekayit: filtrekayit,
      filtreiptal: filtreiptal,
    }
  }

  function filtrele() {
    this.dialogfiltre = true

    var credentials = JSON.parse(window.localStorage.getItem('credentials'));

    var params3 = {
      CompanyCode: credentials.SirketKodu
    }


    this.$http.post(auth.API_URL + 'api/Reference/List', params3, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.Referans = response.body
    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
      } else {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
      }
    })


    this.$http.post(auth.API_URL + 'api/ExpenseCenter/List', params3, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.masrafmerkezi = response.body
    }, (response) => {
      if (response.status === 0) {
        console.log('ea')
      } else {
        console.log('ea')
      }
    })

    this.$http.post(auth.API_URL + 'api/Definitions/CurrentGroupList', params3, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.hesapgurubu = response.body
    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
      } else {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
      }
    })

    this.$http.post(auth.API_URL + 'api/doctype/List', params3, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.evraktipi = response.body

    }, (response) => {
      if (response.status === 0) {
        console.log('ea')
      } else {
        console.log('ea')
      }
    })



  }

  function filtrekayit() {
    this.filtrevarmi = true
    this.getList();
    this.dialogfiltre = false
  }

  function filtreiptal() {
    this.filtrevarmi = false
    this.dialogfiltre = false
  }

  function getList() {

    var bastarih = new Date(this.EkstreHesap.BaslangicTarih)
    var bittarih = new Date(this.EkstreHesap.BitisTarih)

    if (bastarih <= bittarih) {

      if (this.$refs.formcariyegore.validate()) {

        var credentials = JSON.parse(window.localStorage.getItem('credentials'));

        this.EkstreHesap.Cari.Kod = credentials.CariBilgi.Kod
        this.EkstreHesap.SirketKodu = credentials.CariBilgi.SirketKodu

        this.progress = true

        var params = this.EkstreHesap

        this.load1 = false

        this.$http.post(auth.API_URL + 'api/Abstract/ListWithCurrentDetail', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {

          this.progress = false
          this.load1 = true

          if (response.body[0] != undefined) {
            this.items = response.body[0].EkstreList


            var simge = this.getparabirimi()


            if (this.EkstreHesap.RaporDvzTip == 0) {

              this.devirborc = response.body[0].Toplamlar[0].DevirBorc
              this.deviralacak = response.body[0].Toplamlar[0].DevirAlacak

              if (response.body[0].Toplamlar[0].DevirBakiye < 0) {
                this.devirbakiye = response.body[0].Toplamlar[0].DevirBakiye * -1;
                this.devirbakiye = this.devirbakiye.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g,
                  '$1,') + simge + ' A ';

              } else {
                this.devirbakiye = response.body[0].Toplamlar[0].DevirBakiye.toFixed(2).replace(
                  /(\d)(?=(\d{3})+\.)/g,
                  '$1,') + simge + ' B '
              }

              this.donemborc = response.body[0].Toplamlar[0].DonemBorc
              this.donemalacak = response.body[0].Toplamlar[0].DonemAlacak

              if (response.body[0].Toplamlar[0].DonemBakiye < 0) {
                this.donembakiye = response.body[0].Toplamlar[0].DonemBakiye * -1;
                this.donembakiye = this.donembakiye.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g,
                  '$1,') + simge + ' A  ';

              } else {
                this.donembakiye = response.body[0].Toplamlar[0].DonemBakiye.toFixed(2).replace(
                  /(\d)(?=(\d{3})+\.)/g,
                  '$1,') + simge + ' B '
              }

              this.toplamborc = response.body[0].Toplamlar[0].ToplamBorc
              this.toplamalacak = response.body[0].Toplamlar[0].ToplamAlacak

              if (response.body[0].Toplamlar[0].ToplamBakiye < 0) {
                this.toplambakiye = response.body[0].Toplamlar[0].ToplamBakiye * -1;
                this.toplambakiye = this.toplambakiye.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g,
                  '$1,') + simge + ' A  ';

              } else {
                this.toplambakiye = response.body[0].Toplamlar[0].ToplamBakiye.toFixed(2).replace(
                  /(\d)(?=(\d{3})+\.)/g,
                  '$1,') + simge + ' B'
              }
            }

            if (this.EkstreHesap.RaporDvzTip == 1 || this.EkstreHesap.RaporDvzTip == 2) {
              this.dovizToplamlar = response.body[0].Toplamlar
            }


          } else {
            this.text1 = 'Kayıt Bulunamadı.';
            this.snackbar = true;
            this.progress = false;
            this.load1 = true;
            this.items = [];
          }

        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable'
            this.snackbar = true

            this.load1 = true
            this.progress = false

          } else {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
            this.load1 = true
            this.progress = false
          }
        })

      }

    } else {

      this.load1 = true

      this.text1 = 'Başlangıç tarihi bitiş tarihinden büyük olamaz...'
      this.snackbar = true

    }



  }

  function getListHtml() {

    if (this.$refs.formcariyegore.validate()) {

      var credentials = JSON.parse(window.localStorage.getItem('credentials'));

      if (this.tumsirketler == true) {
        this.EkstreHesap.SirketKodu = 0
      } else {
        this.EkstreHesap.SirketKodu = credentials.SirketKodu
      }
      this.progress = true


      var yenidizi = []

      this.EkstreHesap.IstenilenReferanslar.forEach(element => {
        var kayit = {
          Kod: element
        }
        yenidizi.push(kayit)
      });
      this.EkstreHesap.IstenilenReferanslar = yenidizi;

      yenidizi = [];

      this.EkstreHesap.IstenmeyenReferanslar.forEach(element => {
        var kayit = {
          Kod: element
        }
        yenidizi.push(kayit)
      });
      this.EkstreHesap.IstenmeyenReferanslar = yenidizi;

      yenidizi = [];


      this.EkstreHesap.Masraflar.forEach(element => {
        var kayit = {
          Code: element
        }
        yenidizi.push(kayit)
      });
      this.EkstreHesap.Masraflar = yenidizi;
      yenidizi = [];


      this.EkstreHesap.Evraklar.forEach(element => {
        var kayit = {
          Evrakkod: element
        }
        yenidizi.push(kayit)
      });
      this.EkstreHesap.Evraklar = yenidizi;
      yenidizi = [];

      var params = this.EkstreHesap
      this.load1 = false

      this.$http.post(auth.API_URL + 'api/Abstract/ListWithCurrentDetailHtml', params, {
        headers: {
          'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
      }).then((response) => {
        this.load = false
        this.load1 = true
        this.progress = false
        var blob = new Blob([response.data], {
          type: 'application/html'
        });
        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = "HesapEkstre.html";
        link.click();

      }, (response) => {
        if (response.status === 0) {
          this.text = 'Service Unavailable'
          this.snackbar = true
          this.load1 = true
          this.progress = false

        } else {
          this.text = 'Service Unavailable'
          this.snackbar = true
          this.load1 = true
          this.progress = false

        }
      })

    }



  }

  function getListExcel() {
    if (this.$refs.formcariyegore.validate()) {

          var credentials = JSON.parse(window.localStorage.getItem('credentials'));

        this.EkstreHesap.Cari.Kod = credentials.CariBilgi.Kod
        this.EkstreHesap.SirketKodu = credentials.CariBilgi.SirketKodu

        this.progress = true

        this.load1 = false

      var params = this.EkstreHesap


      this.$http.post(auth.API_URL + 'api/Abstract/ListWithCurrentDetailExcel', params, {
        headers: {
          'Authorization': 'Bearer ' + auth.getAuthHeader()
        },
        responseType: "arraybuffer"
      }).then((response) => {
        this.load = false
        this.load1 = true
        this.progress = false
        var blob = new Blob([response.data], {
          type: 'application/xlsx'
        });
        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = "HesapEkstre.xlsx";
        link.click();

      }, (response) => {
        if (response.status === 0) {
          this.text = 'Service Unavailable'
          this.snackbar = true
          this.load1 = true
          this.progress = false

        } else {
          this.text = 'Service Unavailable'
          this.snackbar = true
          this.load1 = true
          this.progress = false

        }
      })

    }



  }


  function carigetir(v) {

    var credentials = JSON.parse(window.localStorage.getItem('credentials'));

    if (v.length >= 0) {
      this.loading = true
      var params = {
        q: v,
        c: credentials.SirketKodu,
      }
      setTimeout(() => {
        this.$http.post(auth.API_URL + 'api/options/CurrentSearch', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          this.statecari = response.body
        }, (response) => {
          if (response.status === 0) {
            this.text = 'Service Unavailable'
            this.snackbar = true
          } else {
            this.text = 'Service Unavailable'
            this.snackbar = true
          }
        })
        this.loading = false
      }, 500)
    }
  }


  function beforeMount() {
    this.headers = this.headerstl
  }
</script>

<style>
  .project.complete {
    border-top: #039BE5;
    border-left: 4px solid #039BE5;
  }

  .project.ongoing {
    border-left: 4px solid orange;
  }

  .project.overdue {
    border-left: 4px solid #ff6347;
  }
</style>